<template>
  <div class="checkbox"
    :class="disabled && 'input-disabled'"
    tabindex="0" 
    role="checkbox"
    :aria-checked="state"
    @click="check()"
    @keyup.space="check()">

    <div v-if="isSwitch" class="checkbox-switch" :class="{'checked': state}">
      <div class='knob-wrapper'>
        <div class='knob'></div>
      </div>
    </div>

    <div v-else class="checkbox-box" :class="{'checked': state}">
    </div>

    <div class="checkbox-label">
      <slot></slot>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, ref, watch } from 'vue'

export default defineComponent({
  name: 'InputCheck',
  emits: ['update:modelValue'],
  props: {
    modelValue: Boolean,
    isSwitch: Boolean,
    disabled: Boolean
  },
  setup(props, { emit }) {   
    const state = ref(props.modelValue)
    watch(() => props.modelValue, (newValue) => {
      state.value = newValue
    })
    function check() {      
      state.value = !state.value
      emit('update:modelValue', Boolean(state.value))
    }
    return { check, state }
  }
})
</script>

<style lang='scss' scoped>
.checkbox {
  display: flex;
  align-items: center;
  outline: none !important;
  touch-action: manipulation;

  &:focus {
    .checkbox-box {
      //box-shadow: 0 0 8px var(--color-primary);
      border-color: var(--color-primary);
    }
  }
}

// CHECK
.checkbox-box {
  width: 1.5rem;
  height: 1.5rem;
  border-radius: .5rem;
  border: 2px solid var(--color-background-input);
  background-color: var(--color-background-input);
  display: flex;
  align-items: center;
  justify-content: center;
  transition: background 0.3s ease;

  &.checked {
    background: var(--color-primary);
    border-color: var(--color-primary);
    &:before {
      content: "check";
      font-family: "Material Icons";
      font-size: 1rem;
      color: var(--color-on-primary);
    }
  }
}

// SWITCH
.checkbox-switch {
  width: 3rem;
  min-width: 3rem;
  height: 1.5rem;
  border-radius: 1.5rem;
  background-color: var(--color-background-input);
  cursor: pointer;
  position: relative;

  &:before {
      content: '';
      position: absolute;
      left: 0;
      width: 100%;
      height: 100%;
      border-radius: 1.5rem;
      background-color: var(--color-primary);
      opacity: 0;
      transition: opacity 0.3s ease;
  }

  .knob-wrapper {
      height: 1.5rem;
      width: 1.5rem;
      transition: transform .3s ease;

      .knob {
          border-radius: 1.5rem;
          height: 100%;
          width: 100%;
          background: white;
          box-shadow: 0 4px 20px rgba(0,0,0,0.1);
          transition: transform .3s ease;
          transform: scale(0.7)
      }

  }
  &:active {
      .knob-wrapper {
          transform: translateX(4px);
      }
  }
  &.checked {
      &:before {
          opacity: 1;
      }
      .knob-wrapper {
          transform: translateX(1.5rem);
      }
      &:active {
          .knob-wrapper {
              transform: translateX(20px);
          }
      }
  }
  &:hover {
      .knob {
          transform: scale(0.8)
      }
  }
}

</style>
